export default "__VITE_PUBLIC_ASSET__e2d3afc4__"